import { createTheme, ThemeOptions } from "@mui/material";
import { AmplifyConfig, InterfaceConfig } from "@interfaces/index";
import { themeBase } from "./_themeBase";

const theme: ThemeOptions = {
  palette: {
    primary: {
      main: "#5568A0",
      dark: "#213F6D",
      light: "#BDBBBB",
      base: "#B7C1DE",
      accent: "#A8B94D",
    },
    components: {
      slider: {
        rail: "#B7C1DE",
        track: "#213F6D",
        thumbIcon: "#F2704F",
        label: "#213F6D",
      },
      progressBar: {
        rail: "#B7C1DE",
        track: "#213F6D",
      },
      phoneInput: {
        main: "#B7C1DE",
      },
      buttonSelect: {
        backgroundColor: "#D8D8D8D8",
        textColor: "#333F48",
        backgroundColorActive: "#5568A0",
        textColorActive: "#FFFFFF",
        bordeColorActive: "#5568A0",
      },
    },
    // screens: {
    //   bofu: {
    //     backgroundColor: "#FFFFFF",
    //     titleColor: "#49A942",
    //     subtitleColor: "#2C2C2C",
    //     iconColor: "#49A942",
    //   },
    // },
  },
};

export const CustomTheme = createTheme(themeBase, theme);

export const interfaceConfig: InterfaceConfig = {
  name: "providencia",
  interest_rate: 30,
  maps: {
    api_key:
      import.meta.env.VITE_ENV === "PROD"
        ? "AIzaSyDAtCLTqWu3XTjTC6AT2ZysdXUtL33bAX4"
        : "AIzaSyAPkyPkzcAbvKAageB8UN25PKbzl4stiWc",
  },
  companyNames: ["Lendit Group SAPI de CV"],
};

export const amplifyConfig: AmplifyConfig = {
  dev: {
    client: {
      userPoolId: "us-east-1_xNemClkcb",
      userPoolClientId: "43gc1fvrdk55b6j4g5nq6k21vo",
    },
    guarantee: {
      userPoolId: "us-east-1_EdJB8vOre",
      userPoolClientId: "1gtf94j5udovq9deu5u13bbhvn",
    },
  },
  prod: {
    client: {
      userPoolId: "us-east-1_FhHFierzr",
      userPoolClientId: "5qvl9t4n2qtvg99rv30t6gqqum",
    },
    guarantee: {
      userPoolId: "us-east-1_78qrlwJTD",
      userPoolClientId: "451cn0u2mau2ipp479c39d75m5",
    },
  },
};
